import { useNavigate, useLocation } from "react-router-dom";
import { ROUTES, AGENT_CENTER_TABS } from "../types/routes";

// 不应该返回的页面列表
const BLOCKED_BACK_ROUTES = [ROUTES.LOGIN, ROUTES.REGISTER];

// AgentCenter Tab 类型
type AgentCenterTabType =
  (typeof AGENT_CENTER_TABS)[keyof typeof AGENT_CENTER_TABS];

// 导航工具函数
export const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    // 导航到指定路径
    navigate: (path: string, options?: { replace?: boolean; state?: any }) => {
      const shouldReplace = options?.replace || location.pathname === path;
      navigate(path, { ...options, replace: shouldReplace });
    },

    // 导航到首页
    goHome: () => navigate(ROUTES.HOME),

    // 导航到维护页面
    goToMaintain: () => navigate(ROUTES.MAINTAIN),

    // 导航到 AgentCenter 的指定 tab
    goToAgentCenter: (
      tab?: AgentCenterTabType,
      options?: { replace?: boolean; state?: any }
    ) => {
      const path = tab
        ? `${ROUTES.AGENT_CENTER}?tab=${tab}`
        : `${ROUTES.AGENT_CENTER}?tab=${AGENT_CENTER_TABS.COMMISSION}`;
      const shouldReplace =
        options?.replace || location.pathname === ROUTES.AGENT_CENTER;
      navigate(path, { ...options, replace: shouldReplace });
    },

    // 智能返回上一页
    // 如果检测到是从登录/注册页面来的，则跳转到首页而不是返回
    goBack: () => {
      const currentPath = location.pathname;
      const state = location.state as any;
      const fromPath = state?.from?.pathname;

      // 当前在注册页：不管从哪里进来的，都返回首页
      if (currentPath === ROUTES.REGISTER) {
        navigate(ROUTES.HOME, { replace: true });
        return;
      }
      // 来源是登录或注册页时，跳转到首页
      if (fromPath && BLOCKED_BACK_ROUTES.includes(fromPath)) {
        navigate(ROUTES.HOME, { replace: true });
        return;
      }
      if (window.history.length <= 1) {
        navigate(ROUTES.HOME, { replace: true });
        return;
      }
      // 否则执行正常的返回操作
      navigate(-1);
    },

    // 获取当前路径
    getCurrentPath: () => location.pathname,

    // 检查是否在指定路径
    isCurrentPath: (path: string) => location.pathname === path,

    // 检查是否在首页
    isHome: () =>
      location.pathname === ROUTES.HOME ||
      location.pathname === ROUTES.HOME_ALT,
  };
};

// 路由常量
export { ROUTES, AGENT_CENTER_TABS } from "../types/routes";
